import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const CONFIGURE = 'CHANNELS/CONFIGURE';

export const configureActionSchema = objectSchemaOf<IConfigureAction>({
  type: Joi.string().required().valid(CONFIGURE),
  payload: objectSchemaOf<IConfigureAction['payload']>({
    contractsVersion: Joi.string().required(),
  }),
});

export interface IConfigureAction {
  type: typeof CONFIGURE;
  payload: {
    /**
     * Version of the contracts library used by clients
     */
    contractsVersion: string;
  };
}

export const configure = actionCreator({
  type: CONFIGURE,
  schema: configureActionSchema,
});
